<template>
  <div class="col-md-12 well repeatable-element row m-1 p-2">
    <div class="controls">
      <button type="button" class="close" @click="$emit('on-remove')">
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <div class="hidden">
      <input
        type="hidden"
        :name="`groups[${index}][id]`"
        :value="type.id"
        class="form-control"
      />
    </div>

    <div class="col-12 mb-4">
      <label>Groepsnaam</label>
      <input
        type="text"
        :name="`groups[${index}][name]`"
        v-model="type.name"
        class="form-control"
      />
    </div>

    <div class="col-12 mb-4">
      <label>Ondertitel</label>
      <input
        type="text"
        :name="`groups[${index}][subtitle]`"
        v-model="type.subtitle"
        class="form-control"
      />
    </div>

    <div class="col-12 mb-4">
      <label>Standaard prijs</label>
      <input
        type="text"
        :name="`groups[${index}][default_price]`"
        v-model="type.default_price"
        class="form-control"
      />
    </div>

    <div class="px-3 col-12">
      <div class="form-group col-12 px-4">
        <FormKit
          :name="`groups[${index}][required]`"
          :value="type.required ? 1 : 0"
          :key="type.required"
          type="hidden"
        />
        <FormKit
          type="checkbox"
          v-model="type.required"
          label="Is verplicht"
          :classes="{
            input: {
              $reset: true,
            },
          }"
          input-class="form-check-input"
        />
      </div>
    </div>

    <div class="px-3 col-12 mb-3">
      <div class="form-group col-12 px-4">
        <div class="mb-2">          
          <label class="form-check-label" :for="`restrict-days-${index}`">
            <input
            type="checkbox"
            class="form-check-input"
            v-model="restrictDays"
            :id="`restrict-days-${index}`"
          /> Deze prijs geldt alleen op bepaalde dagen
          </label>
        </div>

        <div v-if="restrictDays" class="ms-3">
          <div
            v-for="day in weekdays"
            :key="day.value"
            class="form-check form-check-inline"
          >
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                :name="`groups[${index}][weekdays][]`"
                :value="day.value"
                :checked="type.weekdays && type.weekdays.includes(day.value)"
                @change="toggleWeekday(day.value, $event)"
              /> {{ day.label }}
            </label>
          </div>
        </div>

        <input
          v-if="!restrictDays || !type.weekdays || type.weekdays.length === 0"
          type="hidden"
          :name="`groups[${index}][weekdays]`"
          value=""
        />
      </div>
    </div>

    <div v-if="type.prices?.length" class="col-12">
      <div v-for="(price, priceIndex) in type.prices" :key="price.id">
        <price
          v-model="type.prices[priceIndex]"
          :index="index"
          :price-index="priceIndex"
          @on-remove="removePrice(priceIndex)"
        />
      </div>
    </div>

    <input v-else type="hidden" :name="`groups[${index}][prices]`">

    <button
      type="button"
      class="btn btn-primary my-2 btn-sm ml-1"
      @click="addPrice"
    >
      + Prijs toevoegen
    </button>
  </div>
</template>

<script>
import Price from "./Price.vue";

export default {
  components: { Price },
  props: {
    modelValue: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      type: {
        ...this.modelValue,
        weekdays: (this.modelValue.weekdays || []).map(Number),
      },
      required: this.modelValue.required,
      restrictDays: Array.isArray(this.modelValue.weekdays) && this.modelValue.weekdays.length > 0,
      weekdays: [
        { value: 1, label: "Maandag" },
        { value: 2, label: "Dinsdag" },
        { value: 3, label: "Woensdag" },
        { value: 4, label: "Donderdag" },
        { value: 5, label: "Vrijdag" },
        { value: 6, label: "Zaterdag" },
        { value: 7, label: "Zondag" },
      ],
    };
  },
  methods: {
    addPrice() {
      const id = Math.round(Math.random() * 9999);

      this.type.prices.push({
        id,
        value: 0,
        start_date: "",
        end_date: "",
      });
    },
    removePrice(index) {
      this.type.prices.splice(index, 1);
    },
    toggleWeekday(value, event) {
      if (!Array.isArray(this.type.weekdays)) {
        this.type.weekdays = [];
      }
      if (event.target.checked) {
        if (!this.type.weekdays.includes(value)) {
          this.type.weekdays.push(value);
        }
      } else {
        this.type.weekdays = this.type.weekdays.filter((d) => d !== value);
      }
    },
  },
  watch: {
    type: {
      deep: true,
      immediate: false,
      handler(value) {
        this.$emit("update:modelValue", value);
      },
    },
    restrictDays(val) {
      if (!val) {
        this.type.weekdays = [];
      }
    },
  },
};
</script>
